/* Train & Ride — storefront behaviour (no dependencies). */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* Money formatting using the shop's money format */
  function formatMoney(cents, format = window.theme.moneyFormat) {
    const value = Number(cents) / 100;
    const fmt = (n, dec, t = ',', d = '.') => {
      const [i, f] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? d + f : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fmt(value, 2),
      amount_no_decimals: fmt(value, 0),
      amount_with_comma_separator: fmt(value, 2, '.', ','),
      amount_no_decimals_with_comma_separator: fmt(value, 0, '.', ','),
      amount_with_apostrophe_separator: fmt(value, 2, "'", '.'),
    }[k] ?? fmt(value, 2)));
  }

  /* Toast */
  let toastTimer;
  function toast(html) {
    const el = $('[data-toast]');
    if (!el) return;
    el.innerHTML = html;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-on'), 4000);
  }

  function setCartCount(count) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count < 1; });
  }

  /* Mobile drawer: close on backdrop/escape */
  $$('[data-drawer]').forEach((d) => {
    d.addEventListener('toggle', () => document.body.style.overflow = d.open ? 'hidden' : '');
    d.addEventListener('click', (e) => { if (e.target.matches('.drawer-backdrop, [data-drawer-close], [data-drawer-close] *')) { e.preventDefault(); d.open = false; } });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('details[open]').forEach((d) => { d.open = false; d.querySelector('summary')?.focus(); });
  });
  /* Desktop dropdowns: close others / close on outside click */
  document.addEventListener('click', (e) => {
    $$('.hdr__nav details[open]').forEach((d) => { if (!d.contains(e.target)) d.open = false; });
  });

  /* Variant picker */
  $$('[data-product]').forEach((root) => {
    const variants = JSON.parse($('[data-variants]', root)?.textContent || '[]');
    const idInput = $('[name="id"]', root);
    const btn = $('[data-add]', root);
    const priceEl = $('[data-price]', root);
    const update = () => {
      const chosen = $$('[data-option]', root).map((fs) => $('input:checked', fs)?.value ?? $('select', fs)?.value);
      const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
      const buy = $('[data-buy]', root);
      if (!v) { btn.disabled = true; if (buy) buy.disabled = true; btn.textContent = window.theme.strings.unavailable; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      if (buy) buy.disabled = !v.available;
      btn.textContent = v.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
      if (priceEl) {
        const sale = v.compare_at_price > v.price;
        priceEl.classList.toggle('price--sale', sale);
        priceEl.innerHTML = `<span class="price__now">${formatMoney(v.price)}</span>${sale ? `<s>${formatMoney(v.compare_at_price)}</s>` : ''}`;
      }
      if (v.featured_media) {
        const thumb = $(`[data-media-id="${v.featured_media.id}"]`, root);
        thumb?.click();
      }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    root.addEventListener('change', (e) => { if (e.target.closest('[data-option]')) update(); });

    /* Gallery thumbs */
    $$('.gallery__thumb', root).forEach((t) => t.addEventListener('click', () => {
      const main = $('.gallery__main img', root);
      main.src = t.dataset.src; main.srcset = t.dataset.srcset || ''; main.alt = t.querySelector('img')?.alt || '';
      $$('.gallery__thumb', root).forEach((x) => x.setAttribute('aria-current', String(x === t)));
    }));
  });

  /* Quantity steppers */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    const next = Math.max(Number(input.min || 0), Number(input.value || 0) + Number(b.dataset.qty));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart drawer */
  const drawer = $('[data-cart-drawer]');
  let lastFocus = null;
  const openDrawer = () => {
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => $('.cd__close', drawer)?.focus(), 60);
    return true;
  };
  const closeDrawer = () => {
    if (!drawer?.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    lastFocus?.focus?.();
  };
  // Swap in freshly rendered drawer markup from the Section Rendering API
  const renderDrawer = (html) => {
    if (!drawer || !html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.cd__inner');
    if (fresh) $('.cd__inner', drawer).replaceWith(fresh);
  };
  const jsonHeaders = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cd-close]')) { closeDrawer(); return; }
    const opener = e.target.closest('[data-cart-open]');
    if (opener && openDrawer()) e.preventDefault();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  // Quantity / remove inside the drawer
  drawer?.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-cd-line]');
    if (!b) return;
    drawer.classList.add('is-busy');
    try {
      const res = await fetch(window.theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { ...jsonHeaders, 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(b.dataset.cdLine), quantity: Math.max(0, Number(b.dataset.cdQty)), sections: 'cart-drawer', sections_url: location.pathname }),
      });
      const cart = await res.json();
      if (!res.ok) throw new Error(cart.description || cart.message);
      renderDrawer(cart.sections?.['cart-drawer']);
      setCartCount(cart.item_count);
    } catch (err) {
      toast(`<span>${err.message || 'Error'}</span>`);
    } finally {
      drawer.classList.remove('is-busy');
    }
  });

  /* AJAX add to cart. "Buy now" buttons (name="return_to") add the item, then go to checkout. */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const submitter = e.submitter;
    const buyNow = submitter?.name === 'return_to';
    const body = new FormData(form);
    body.delete('return_to');
    if (drawer && !buyNow) { body.append('sections', 'cart-drawer'); body.append('sections_url', location.pathname); }
    const buttons = $$('[type="submit"]', form);
    buttons.forEach((b) => { b.disabled = true; });
    submitter?.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(window.theme.routes.cartAdd + '.js', { method: 'POST', headers: jsonHeaders, body });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message);
      if (buyNow) { location.href = window.theme.routes.checkout; return; }
      renderDrawer(data.sections?.['cart-drawer']);
      const cart = await fetch(window.theme.routes.cart + '.js', { headers: jsonHeaders }).then((r) => r.json());
      setCartCount(cart.item_count);
      if (!openDrawer()) {
        toast(`<span>${window.theme.strings.added}: <strong>${data.product_title}</strong></span><a class="link-arrow" href="${window.theme.routes.cart}">${window.theme.strings.viewCart}</a>`);
      }
    } catch (err) {
      toast(`<span>${err.message || 'Error'}</span>`);
    } finally {
      submitter?.removeAttribute('aria-busy');
      buttons.forEach((b) => { b.disabled = false; });
    }
  });

  /* Sort select on collections */
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => {
    const url = new URL(location.href); url.searchParams.set('sort_by', s.value); url.searchParams.delete('page'); location.href = url;
  }));

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    $$('[data-reveal]').forEach((el) => io.observe(el));
  } else {
    $$('[data-reveal]').forEach((el) => el.classList.add('is-in'));
  }
})();

/* Slideshow: dots, scroll sync and optional autoplay */
document.querySelectorAll('[data-slideshow]').forEach((root) => {
  const track = root.querySelector('[data-track]');
  const dots = [...root.querySelectorAll('[data-dot]')];
  if (!track || dots.length < 2) return;
  const go = (i) => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  const current = () => Math.round(track.scrollLeft / track.clientWidth);
  dots.forEach((d) => d.addEventListener('click', () => go(Number(d.dataset.dot))));
  track.addEventListener('scroll', () => {
    const i = current();
    dots.forEach((d, j) => d.setAttribute('aria-current', String(i === j)));
  }, { passive: true });
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (root.dataset.autoplay === 'true' && !reduced) {
    let paused = false;
    root.addEventListener('pointerenter', () => paused = true);
    root.addEventListener('pointerleave', () => paused = false);
    root.addEventListener('focusin', () => paused = true);
    root.addEventListener('focusout', () => paused = false);
    setInterval(() => { if (!paused && !document.hidden) go((current() + 1) % dots.length); }, Number(root.dataset.speed || 6) * 1000);
  }
});

/* Product recommendations: replace the fallback with Shopify's recommendations when available */
document.querySelectorAll('[data-recs][data-url]').forEach(async (el) => {
  try {
    const html = await fetch(el.dataset.url).then((r) => (r.ok ? r.text() : ''));
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs]');
    if (fresh && fresh.querySelector('.card')) {
      el.innerHTML = fresh.innerHTML;
      el.querySelectorAll('[data-reveal]').forEach((n) => n.classList.add('is-in'));
    }
  } catch (e) { /* keep the fallback products */ }
});
